import React from 'react';

const AdvancedFiltersSectionContext = React.createContext({
  name: null,
});

export default AdvancedFiltersSectionContext;
